import { ACCOUNT_DELETION_PUBLIC_PATH } from '../constants/accountDeletionContent';
import { useI18n } from '../i18n';
import { publicPath } from '../publicPath';
import styles from './ProfileMenu.module.css';

type ProfileHubDeleteAccountPanelProps = {
  onDelete: () => void;
  error?: string | null;
};

export function ProfileHubDeleteAccountPanel({ onDelete, error }: ProfileHubDeleteAccountPanelProps) {
  const { t, language } = useI18n();
  const detailsPath = language === 'he' ? `${ACCOUNT_DELETION_PUBLIC_PATH}he/` : ACCOUNT_DELETION_PUBLIC_PATH;
  return (
    <div>
      <p className={styles.hubTermsIntro}>{t('profile.hub.deleteAccountSummary')}</p>
      <p className={styles.hubTermsSectionBody}>
        <a
          href={publicPath(detailsPath)}
          target="_blank"
          rel="noopener noreferrer"
          onClick={(event) => event.stopPropagation()}
        >
          {t('profile.hub.deleteAccountDetails')}
        </a>
      </p>
      <div className={styles.hubTermsEraseBlock}>
        <button type="button" className={styles.hubRowActionBtnDanger} onClick={onDelete}>
          {t('profile.hub.deleteAccountButton')}
        </button>
        {error ? (
          <p className={styles.hubRowExpandError} role="alert">
            {error}
          </p>
        ) : null}
      </div>
    </div>
  );
}
